document.getElementById("trendingTab").style.display ="none";
document.getElementById("bestSellerTab").style.display ="none";
document.getElementById("newBtn").style.color = "black";
document.getElementById("newBtn").style.borderColor = "black";
function showNew() {
document.getElementById("trendingTab").style.display ="none";
document.getElementById("trendingBtn").style.borderColor = "#696969";
document.getElementById("trendingBtn").style.color = "#696969";
document.getElementById("bestSellerTab").style.display ="none";
document.getElementById("bestSellerBtn").style.borderColor = "#696969";
document.getElementById("bestSellerBtn").style.color = "#696969";
document.getElementById("newTab").style.display ="Block";
document.getElementById("newBtn").style.borderColor = "black";
document.getElementById("newBtn").style.color = "black";
}
function showTrending() {
document.getElementById("bestSellerTab").style.display ="none";
document.getElementById("bestSellerBtn").style.borderColor = "#696969";
document.getElementById("bestSellerBtn").style.color = "#696969";
document.getElementById("newTab").style.display ="none";
document.getElementById("newBtn").style.borderColor = "#696969";
document.getElementById("newBtn").style.color = "#696969";
document.getElementById("trendingTab").style.display ="Block";
document.getElementById("trendingBtn").style.borderColor = "black";
document.getElementById("trendingBtn").style.color = "black";

}
function showBestSeller() {
document.getElementById("newTab").style.display ="none";
document.getElementById("newBtn").style.borderColor = "#696969";
document.getElementById("newBtn").style.color = "#696969";
document.getElementById("trendingTab").style.display ="none";
document.getElementById("trendingBtn").style.borderColor = "#696969";
document.getElementById("trendingBtn").style.color = "#696969";
document.getElementById("bestSellerTab").style.display ="Block";
document.getElementById("bestSellerBtn").style.borderColor = "black";
document.getElementById("bestSellerBtn").style.color = "black";
}

document.getElementById("newBtn").onclick = function() {showNew()};
document.getElementById("bestSellerBtn").onclick = function() {showBestSeller()};
document.getElementById("trendingBtn").onclick = function() {showTrending()};
